import { stores, fromJS, toJS, uuid } from 'core';

import { defaultLocale } from 'locale';

export default function({
    id, media, icon, link, section = '',
    title, description, fullDescription,
    titleEn, descriptionEn, fullDescriptionEn,
    images = [], videos = []
}) {

    const { app: { get, edit } } = stores();

    window._get = get;

    const locale = get('locale') || defaultLocale;

    const isEN = locale == 'En';

    id = id || uuid();

    const card = {
        id, media, icon, section, link,
        images, videos,

        title: isEN ? titleEn : title,
        description: isEN ? descriptionEn : description,
        fullDescription: isEN ? fullDescriptionEn : fullDescription,

        /* translations */
        titlePt: title, descriptionPt: description, fullDescriptionPt: fullDescription,
        titleEn: titleEn, descriptionEn: descriptionEn, fullDescriptionEn: fullDescriptionEn
    };

    edit('cards', `${id}`, fromJS(card));

    return true;
}



// WEBPACK FOOTER //
// ./app/a/cards/add.js